module.exports = __webpack_public_path__ + "pigmentace_2_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/pigmentace_2_after.jpg
// module id = 971
// module chunks = 0